<script>
export default {};
</script>

<template>
  <div>
    <!--START PROCESS-->
    <section class="section pt-4" id="team">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <h1 class="section-title text-center">¡Sigue estos sencillos pasos!</h1>
            <div class="section-title-border margin-t-20"></div>
            <p class="section-subtitle text-muted text-center font-secondary padding-t-30">Ahorra dinero comprando tu
              seguro en línea y no pagues multas cuando salgas de viaje.</p>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-6 text-center process-left-icon-1">
            <i class="pe-7s-angle-right"></i>
          </div>
          <div class="col-lg-6 text-center process-left-icon-2">
            <i class="pe-7s-angle-right"></i>
          </div>
        </div>
        <div class="row margin-t-50">
          <div class="col-lg-4 plan-line">
            <div class="text-center process-box">
              <i class="pe-7s-car text-custom"></i>
              <h4 class="padding-t-15">Seleccione el producto</h4>
              <p class="text-muted">Auto Mexicano para viajar a USA</p>
            </div>
          </div>
          <div class="col-lg-4 plan-line">
            <div class="text-center process-box">
              <i class="pe-7s-id text-custom"></i>
              <h4 class="padding-t-15">Agrega tu información</h4>
              <p class="text-muted">Dentro de la pagina llena el formulario.</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="text-center process-box">
              <i class="pe-7s-piggy text-custom"></i>
              <h4 class="padding-t-15">Pagar</h4>
              <p class="text-muted">Y listo tu poliza esta lista de usarse.</p>
            </div>
          </div>
          <div class="text-center mx-auto">
            <a href="https://public.nhseguros.com/#!policyindividual/index?code=22807&lang=es" Target="_blank"
              class="btn btn-custom waves-light waves-effect margin-t-50">
              Comprar poliza
            </a>
          </div>
        </div>
      </div>
    </section>
    <!--END PROCESS-->
  </div>
</template>